import { render, staticRenderFns } from "./StockProductList.vue?vue&type=template&id=1fdf09c4&scoped=true&"
import script from "./StockProductList.vue?vue&type=script&lang=js&"
export * from "./StockProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdf09c4",
  null
  
)

export default component.exports